import { Link } from 'react-router-dom';
import { articles } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = articles.filter((a) => a.featured);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            精选漫画推荐
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            编辑精选的优质哺乳主题漫画，每一篇都值得细细品读
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-accent-200 transition-all duration-300 no-underline"
            >
              <div className="relative w-full h-[200px] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`${article.title} - 奶水漫画`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-white/90 text-foreground-800">
                    {article.readTime} 分钟阅读
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors" style={{ fontFamily: 'var(--font-heading)' }}>
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.publishDate}</span>
                  <span>{article.viewCount.toLocaleString()} 次阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}